import { render, staticRenderFns } from "./SliceTextImages.vue?vue&type=template&id=72d4571d&lang=pug&"
import script from "./SliceTextImages.vue?vue&type=script&lang=js&"
export * from "./SliceTextImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports